<template>
  <BoardView :pagination="pagination" :title="$t('title')" :total="total">
    <Route
      v-if="hasRole('>=MODERATOR')"
      slot="button"
      class="Btn withIcon icon-side-left info"
      to="PageBatchesAdd">
      <Icon name="plus" /> {{ $t('button') }}
    </Route>
    <BoardTable
      :hasResults="!!total"
      :isFetching="isFetching"
      :pagination="pagination">
      <RecordPageBatch
        v-for="pageBatch in results"
        :key="pageBatch.id"
        :pageBatch="pageBatch" />
    </BoardTable>
    <router-view />
  </BoardView>
</template>

<script>
import RecordPageBatch from './components/RecordPageBatch'
import Table from '@mixins/Table'

export default {
  mixins: [Table],
  components: { RecordPageBatch },
  data() {
    return {
      paginationOptions: {
        name: 'adminPageBatches',
        service: 'pageBatch',
        tabs: [
          {
            label: this.$t('all'),
            value: null,
          },
        ],
        tabsIndexes: [0],
      },
    }
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "title": "Page batches",
    "button": "Add new batch",
    "all": "All"
  }
}
</i18n>
